import React from 'react';
import { useSiteMetadata } from '../hooks/use-site-metadata';
import { Helmet } from 'react-helmet';
import { isBrowser } from '../helpers/isBrowser';

export const Seo = ({ title, description, pathname, children }) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    siteUrl,
  } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${image}`,
    url: `${siteUrl}${pathname || ``}`,
  };
  const currentPath = isBrowser && window.location.href;

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:url" content={seo.url} />
      <link rel="icon" href="/favicon.ico" />
      <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
      {currentPath && (
        <link
          rel="canonical"
          href={`${currentPath.slice(-1) === '/' ? currentPath : currentPath + '/'}`}
        />
      )}
      {children}
    </Helmet>
  );
};
